// src/services/finance/invoice.service.js
import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}invoice-payments/`;

export default {
  list(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },

  exportPdf(params = {}) {
    return axios.get(`${API_URL}export/pdf`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportExcel(params = {}) {
    return axios.get(`${API_URL}export/excel`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
};
